import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";

import useStore from "../services/store/useStore";
import { ManageService } from "../services/Services";

//obtenemos conversion segun monto y coin seleccionada
//obtenemos address de la red según coin y network seleccionada
export const useInitCryptoPayment = platform => {
    const { currencySelected, networkSelected, currentStepZinli, setAddressToPay } = useStore(state => state);

    const [isLoadingConversion, setIsLoadingConversion] = useState(false);
    const [isLoadingAddress, setIsLoadingAddress] = useState(false);
    const [cryptoAmount, setCryptoAmount] = useState(null);

    const getConversionCryptoAmount = useCallback(async (platform, coin, amount) => {
        setCryptoAmount("");
        setIsLoadingConversion(true);
        try {
            const cryptoAmountData = await ManageService.getCryptoConversion(platform, coin, amount);
            setCryptoAmount(cryptoAmountData);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoadingConversion(false);
        }
    }, []);

    const getCryptoAddress = useCallback(async (platform, coin, network) => {
        setAddressToPay("");
        setIsLoadingAddress(true);
        try {
            const cryptoAddressData = await ManageService.getCryptoAddress(platform, coin, network);
            setAddressToPay(cryptoAddressData);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoadingAddress(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (platform && currencySelected?.value && networkSelected?.value) {
            getCryptoAddress(platform, currencySelected?.value, networkSelected?.value);
        }

        if (platform && currencySelected?.value && currentStepZinli?.data?.amount) {
            getConversionCryptoAmount(platform, currencySelected?.value, currentStepZinli.data.amount);
        }
    }, [
        platform,
        currencySelected,
        networkSelected,
        currentStepZinli.data.amount,
        getCryptoAddress,
        getConversionCryptoAmount,
    ]);

    return { isLoadingConversion, isLoadingAddress, cryptoAmount };
};
